import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";

const LabelError = ({ text }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography style={{color: "#f44336", background: "#ecb6b6"}} align="center">
        {t(text)}
      </Typography>
    </>
  );
};

export default LabelError;
